import { render, staticRenderFns } from "./JobSeekersPIP.vue?vue&type=template&id=cb9643ba&scoped=true&"
import script from "./JobSeekersPIP.vue?vue&type=script&lang=js&"
export * from "./JobSeekersPIP.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekersPIP.vue?vue&type=style&index=0&id=cb9643ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9643ba",
  null
  
)

export default component.exports